/* ============================================================
   Extensiones Orgánicas — shared UI
   Header behavior, mobile nav, cart (localStorage + Shopify
   cart-permalink checkout), drawer, quick-view, reveals,
   parallax, count-ups, toasts. Comments in English.
   ============================================================ */

"use strict";

var REDUCED = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

/* ---------- tiny helpers ---------- */
function $(s, c) { return (c || document).querySelector(s); }
function $$(s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); }
function esc(s) { return String(s).replace(/[&<>"']/g, function (m) { return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[m]; }); }

/* ============================================================
   CART
   ============================================================ */
var Cart = {
  KEY: "eo_cart_v1",
  items: [],

  load: function () {
    try { this.items = JSON.parse(localStorage.getItem(this.KEY)) || []; }
    catch (e) { this.items = []; }
  },
  save: function () {
    localStorage.setItem(this.KEY, JSON.stringify(this.items));
    renderCartUI();
  },
  add: function (lineId, code, qty) {
    var line = getLine(lineId);
    if (!line) return;
    var c = getColor(line, code);
    var found = this.items.find(function (i) { return i.variantId === c.variantId; });
    if (found) found.qty += qty || 1;
    else this.items.push({ variantId: c.variantId, lineId: lineId, code: c.code, qty: qty || 1 });
    this.save();
    openDrawer();
  },
  setQty: function (variantId, qty) {
    var it = this.items.find(function (i) { return i.variantId === variantId; });
    if (!it) return;
    it.qty = Math.max(0, qty);
    if (it.qty === 0) this.items = this.items.filter(function (i) { return i.variantId !== variantId; });
    this.save();
  },
  remove: function (variantId) {
    this.items = this.items.filter(function (i) { return i.variantId !== variantId; });
    this.save();
  },
  count: function () { return this.items.reduce(function (n, i) { return n + i.qty; }, 0); },
  subtotal: function () {
    return this.items.reduce(function (n, i) {
      var line = getLine(i.lineId);
      return n + (line ? line.price * i.qty : 0);
    }, 0);
  },
  checkoutUrl: function () {
    if (!this.items.length) return null;
    return SHOP_URL + "/cart/" + this.items.map(function (i) { return i.variantId + ":" + i.qty; }).join(",");
  }
};

/* ============================================================
   Shared chrome injected at runtime (drawer, veil, toast, modal)
   ============================================================ */
function injectChrome() {
  var tpl = document.createElement("div");
  tpl.innerHTML =
    '<div class="veil" id="veil"></div>' +
    '<aside class="drawer" id="drawer" role="dialog" aria-modal="true" aria-label="Cesta de compra">' +
      '<div class="d-head"><h2>Tu cesta</h2>' +
      '<button class="icon-btn" id="drawer-close" aria-label="Cerrar cesta">' + ICONS.close + "</button></div>" +
      '<div class="freebar" id="freebar"></div>' +
      '<div class="d-items" id="d-items"></div>' +
      '<div id="d-upsell"></div>' +
      '<div class="d-foot" id="d-foot"></div>' +
    "</aside>" +
    '<div class="modal" id="modal" role="dialog" aria-modal="true">' +
      '<div class="m-veil" data-close-modal></div>' +
      '<div class="m-box"><button class="m-close" data-close-modal aria-label="Cerrar">' + ICONS.close + '</button><div id="modal-body"></div></div>' +
    "</div>" +
    '<div class="toast" id="toast" role="status" aria-live="polite"></div>';
  while (tpl.firstChild) document.body.appendChild(tpl.firstChild);

  $("#veil").addEventListener("click", closeAllOverlays);
  $("#drawer-close").addEventListener("click", closeDrawer);
  $("#modal").addEventListener("click", function (e) {
    if (e.target.closest("[data-close-modal]")) closeModal();
  });
  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape") closeAllOverlays();
  });
}

var ICONS = {
  close: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M5 5l14 14M19 5L5 19"/></svg>',
  bag: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M6 8h12l1 13H5L6 8z"/><path d="M9 10V6a3 3 0 0 1 6 0v4"/></svg>',
  menu: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M3 7h18M3 12h18M3 17h18"/></svg>',
  check: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M4 12.5l5 5L20 6.5"/></svg>',
  eye: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M2 12s3.5-6.5 10-6.5S22 12 22 12s-3.5 6.5-10 6.5S2 12 2 12z"/><circle cx="12" cy="12" r="2.6"/></svg>',
  arrow: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" width="18" height="18"><path d="M4 12h15m-6-6 6 6-6 6"/></svg>'
};

/* ---------- overlays ---------- */
function openDrawer() {
  renderCartUI();
  $("#drawer").classList.add("open");
  $("#veil").classList.add("show");
  document.body.style.overflow = "hidden";
}
function closeDrawer() {
  $("#drawer").classList.remove("open");
  if (!$("#modal").classList.contains("show")) {
    $("#veil").classList.remove("show");
    document.body.style.overflow = "";
  }
}
function openModal(html, zoom) {
  var m = $("#modal");
  m.classList.toggle("zoom", !!zoom);
  $("#modal-body").innerHTML = html;
  m.classList.add("show");
  document.body.style.overflow = "hidden";
}
function closeModal() {
  $("#modal").classList.remove("show");
  if (!$("#drawer").classList.contains("open")) document.body.style.overflow = "";
}
function closeAllOverlays() {
  closeModal();
  closeDrawer();
  var nav = $("#nav-mobile");
  if (nav) { nav.classList.remove("open"); document.body.style.overflow = ""; }
  $("#veil").classList.remove("show");
}

var toastTimer;
function toast(msg) {
  var t = $("#toast");
  t.innerHTML = ICONS.check + "<span>" + esc(msg) + "</span>";
  t.classList.add("show");
  clearTimeout(toastTimer);
  toastTimer = setTimeout(function () { t.classList.remove("show"); }, 2800);
}

/* ---------- cart UI ---------- */
function renderCartUI() {
  /* header badge */
  $$(".cart-count").forEach(function (b) {
    var n = Cart.count();
    b.textContent = n;
    b.classList.toggle("hide", n === 0);
  });

  var itemsEl = $("#d-items");
  if (!itemsEl) return;

  var sub = Cart.subtotal();

  /* free-shipping progress */
  var fb = $("#freebar");
  if (Cart.items.length === 0) {
    fb.innerHTML = "";
  } else if (sub >= FREE_SHIPPING_THRESHOLD) {
    fb.innerHTML = "<b>Enhorabuena</b> — tu pedido tiene <b>envío gratis</b>." +
      '<div class="track"><div class="fill" style="width:100%"></div></div>';
  } else {
    var missing = FREE_SHIPPING_THRESHOLD - sub;
    fb.innerHTML = "Te faltan <b>" + fmtPrice(missing) + "</b> para el envío gratis." +
      '<div class="track"><div class="fill" style="width:' + Math.min(100, (sub / FREE_SHIPPING_THRESHOLD) * 100) + '%"></div></div>';
  }

  /* items */
  if (Cart.items.length === 0) {
    itemsEl.innerHTML = '<div class="d-empty"><div class="big">Tu cesta está vacía</div>' +
      '<p>Descubre la colección y encuentra tu tono perfecto.</p>' +
      '<p style="margin-top:1.4rem"><a class="btn btn-primary" href="/pages/coleccion">Ver la colección</a></p></div>';
  } else {
    itemsEl.innerHTML = Cart.items.map(function (i) {
      var line = getLine(i.lineId);
      var c = getColor(line, i.code);
      return '<div class="d-item">' +
        '<a href="/pages/producto?p=' + line.id + "&color=" + encodeURIComponent(c.code) + '"><img src="' + EOURL(line.imgDir + "/" + c.file) + '" alt="' + esc(line.name) + '" width="74" height="93"></a>' +
        '<div><div class="n">' + esc(line.name) + '</div>' +
        '<div class="c"><span class="chip-dot" style="background:' + c.info.hex + '"></span>' + esc(c.info.name) + " · " + c.code + "</div>" +
        '<div class="qty"><button data-dq="' + i.variantId + '" aria-label="Restar">−</button><output>' + i.qty + '</output><button data-iq="' + i.variantId + '" aria-label="Sumar">+</button></div></div>' +
        '<div class="col-r"><span class="p">' + fmtPrice(line.price * i.qty) + '</span>' +
        '<button class="rm" data-rm="' + i.variantId + '">Eliminar</button></div>' +
        "</div>";
    }).join("");
  }

  /* upsell: suggest a coletero when the cart has none */
  var upsellEl = $("#d-upsell");
  var hasColetero = Cart.items.some(function (i) { return getLine(i.lineId).category === "coleteros"; });
  if (Cart.items.length > 0 && !hasColetero) {
    var lola = getLine("coletero-lola");
    var match = Cart.items[0].code;
    var mc = getColor(lola, match);
    upsellEl.innerHTML = '<div class="d-upsell">' +
      '<img src="' + EOURL(lola.imgDir + "/" + mc.file) + '" alt="' + esc(lola.name) + '" width="54" height="54">' +
      '<div class="t"><b>Completa tu look</b>' + esc(lola.name) + " · " + esc(mc.info.name) + " · " + fmtPrice(lola.price) + "</div>" +
      '<button data-upsell="' + mc.code + '">Añadir</button></div>';
  } else {
    upsellEl.innerHTML = "";
  }

  /* footer */
  var foot = $("#d-foot");
  if (Cart.items.length === 0) {
    foot.innerHTML = "";
  } else {
    foot.innerHTML =
      '<div class="tot"><span>Subtotal</span><span>' + fmtPrice(sub) + "</span></div>" +
      klarnaLine(sub) +
      '<p class="note" style="margin-top:0.7rem">IVA incluido. Envío calculado en el pago seguro de Shopify.</p>' +
      '<a class="btn btn-bronze" href="' + Cart.checkoutUrl() + '">Finalizar compra</a>';
  }
}

/* Delegated clicks for cart controls & upsell */
document.addEventListener("click", function (e) {
  var t;
  if ((t = e.target.closest("[data-iq]"))) {
    var it = Cart.items.find(function (i) { return i.variantId === t.dataset.iq; });
    if (it) Cart.setQty(t.dataset.iq, it.qty + 1);
  } else if ((t = e.target.closest("[data-dq]"))) {
    var it2 = Cart.items.find(function (i) { return i.variantId === t.dataset.dq; });
    if (it2) Cart.setQty(t.dataset.dq, it2.qty - 1);
  } else if ((t = e.target.closest("[data-rm]"))) {
    Cart.remove(t.dataset.rm);
  } else if ((t = e.target.closest("[data-upsell]"))) {
    Cart.add("coletero-lola", t.dataset.upsell, 1);
    toast("Coletero añadido a tu cesta");
  } else if ((t = e.target.closest("[data-open-cart]"))) {
    e.preventDefault();
    openDrawer();
  } else if ((t = e.target.closest("[data-qv]"))) {
    e.preventDefault();
    quickView(t.dataset.qv);
  }
});

/* ============================================================
   Quick view
   ============================================================ */
function quickView(lineId) {
  var line = getLine(lineId);
  if (!line) return;
  var sel = line.colors[0][0];

  function html() {
    var c = getColor(line, sel);
    return '<div class="qv">' +
      '<div class="qv-ph' + (line.imgFit === "contain" ? " fit-contain" : "") + '"><img id="qv-img" src="' + EOURL(line.imgDir + "/" + c.file) + '" alt="' + esc(line.name) + '"></div>' +
      "<div>" +
      '<p class="eyebrow">' + esc(CATEGORIES[line.category].name) + "</p>" +
      "<h3 style='font-size:1.9rem'>" + esc(line.name) + "</h3>" +
      '<p class="sub" style="color:var(--taupe);font-size:.85rem;margin-top:.3rem">' + esc(line.subtitle) + "</p>" +
      '<p class="price" style="font-family:var(--serif);font-size:1.5rem;margin-top:.8rem">' + fmtPrice(line.price) + ' <small style="font-size:.6em;color:var(--taupe)">IVA incl.</small></p>' +
      '<div class="swatch-block"><div class="swatch-label"><b>Tono</b></div>' +
      '<div class="swatch-grid" id="qv-swatches">' + line.colors.map(function (col) {
        return '<button class="swatch' + (col[0] === sel ? " selected" : "") + '" data-qvc="' + col[0] + '" aria-label="' + esc(COLOR_INFO[col[0]].name) + '"><img src="' + EOURL(line.imgDir + "/" + col[1]) + '" alt="" loading="lazy"></button>';
      }).join("") + "</div>" +
      '<p class="swatch-name" id="qv-name">' + esc(getColor(line, sel).info.name) + " · " + sel + "</p></div>" +
      '<div class="qty-cta" style="margin-top:1.2rem">' +
      '<button class="btn btn-primary" id="qv-add" style="flex:1">Añadir a la cesta</button></div>' +
      '<p style="margin-top:1.1rem"><a class="btn-line" href="/pages/producto?p=' + line.id + "&color=" + encodeURIComponent(sel) + '">Ver detalles <span class="arr">' + ICONS.arrow + "</span></a></p>" +
      "</div></div>";
  }

  openModal(html());

  $("#modal").addEventListener("click", function handler(e) {
    var s = e.target.closest("[data-qvc]");
    if (s) {
      sel = s.dataset.qvc;
      var c = getColor(line, sel);
      $("#qv-img").src = EOURL(line.imgDir + "/" + c.file);
      $("#qv-name").textContent = c.info.name + " · " + sel;
      $$("#qv-swatches .swatch").forEach(function (x) { x.classList.toggle("selected", x.dataset.qvc === sel); });
      var link = $("#modal .btn-line");
      if (link) link.href = "/pages/producto?p=" + line.id + "&color=" + encodeURIComponent(sel);
    }
    if (e.target.closest("#qv-add")) {
      closeModal();
      Cart.add(line.id, sel, 1);
    }
    if (!$("#modal").classList.contains("show")) $("#modal").removeEventListener("click", handler);
  });
}

/* ============================================================
   Shared product card renderer
   ============================================================ */
/* Card shows a single image — no secondary image swap on hover. */
function productCard(line, opts) {
  opts = opts || {};
  var c0 = line.colors[0];
  var useCard = opts.useCardImg && line.cardImg;
  var img1 = EOURL(useCard ? line.cardImg : line.imgDir + "/" + c0[1]);
  /* Lines flagged imgFit:"contain" show their own photos uncropped */
  var fitCls = !useCard && line.imgFit === "contain" ? " fit-contain" : "";
  var dots = line.colors.slice(0, 5).map(function (c) {
    return '<span class="chip-dot" style="background:' + COLOR_INFO[c[0]].hex + '"></span>';
  }).join("");
  var more = line.colors.length > 5 ? '<span class="more">+' + (line.colors.length - 5) + "</span>" : "";
  return '<article class="pcard reveal" style="--d:' + (opts.delay || 0) + 's">' +
    '<div class="ph-wrap">' +
    '<a class="ph' + fitCls + '" href="/pages/producto?p=' + line.id + '" aria-label="' + esc(line.name) + '">' +
    '<span class="badge">' + esc(line.badge) + "</span>" +
    '<img class="main" src="' + img1 + '" alt="' + esc(line.name) + " — " + esc(line.tagline) + '" loading="lazy" width="600" height="750">' +
    "</a>" +
    '<button class="quick" data-qv="' + line.id + '" aria-label="Vista rápida de ' + esc(line.name) + '">' + ICONS.eye + "</button>" +
    "</div>" +
    '<div class="body"><h3><a href="/pages/producto?p=' + line.id + '">' + esc(line.name) + "</a></h3>" +
    '<span class="sub">' + esc(line.subtitle) + "</span>" +
    '<div class="price-row"><span class="price">' + fmtPrice(line.price) + "</span>" +
    '<span class="chips">' + dots + more + "</span></div></div>" +
    "</article>";
}

/* ============================================================
   Header / nav / effects
   ============================================================ */
function initHeader() {
  var header = $(".site-header");
  if (!header) return;
  var onScroll = function () {
    header.classList.toggle("scrolled", window.scrollY > 60);
  };
  window.addEventListener("scroll", onScroll, { passive: true });
  onScroll();

  var toggle = $(".nav-toggle");
  var nav = $("#nav-mobile");
  if (toggle && nav) {
    toggle.addEventListener("click", function () {
      nav.classList.add("open");
      document.body.style.overflow = "hidden";
    });
    $(".nav-close", nav).addEventListener("click", function () {
      nav.classList.remove("open");
      document.body.style.overflow = "";
    });
  }
}

function initReveals() {
  var els = $$(".reveal");
  if (!("IntersectionObserver" in window) || REDUCED) {
    els.forEach(function (el) { el.classList.add("in"); });
    return;
  }
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (en) {
      if (en.isIntersecting) { en.target.classList.add("in"); io.unobserve(en.target); }
    });
  }, { threshold: 0.12, rootMargin: "0px 0px -4% 0px" });
  els.forEach(function (el) { io.observe(el); });
}

/* Scroll-driven parallax on [data-plx] elements (GPU transforms only). */
function initParallax() {
  if (REDUCED) return;
  var els = $$("[data-plx]");
  if (!els.length) return;
  var ticking = false;
  function update() {
    var vh = window.innerHeight;
    els.forEach(function (el) {
      var r = el.parentElement.getBoundingClientRect();
      if (r.bottom < -80 || r.top > vh + 80) return;
      var speed = parseFloat(el.dataset.plx) || 0.2;
      var offset = (r.top + r.height / 2 - vh / 2) * speed;
      el.style.transform = "translate3d(0," + offset.toFixed(1) + "px,0)";
    });
    ticking = false;
  }
  window.addEventListener("scroll", function () {
    if (!ticking) { ticking = true; requestAnimationFrame(update); }
  }, { passive: true });
  update();
}

/* Count-up stats: <b data-count="98" data-suffix="%"> */
function initCounters() {
  var els = $$("[data-count]");
  if (!els.length) return;
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (en) {
      if (!en.isIntersecting) return;
      io.unobserve(en.target);
      var el = en.target, target = parseFloat(el.dataset.count), suffix = el.dataset.suffix || "";
      if (REDUCED) { el.textContent = target + suffix; return; }
      var t0 = null;
      function step(ts) {
        if (!t0) t0 = ts;
        var p = Math.min(1, (ts - t0) / 1400);
        var eased = 1 - Math.pow(1 - p, 3);
        el.textContent = Math.round(target * eased) + suffix;
        if (p < 1) requestAnimationFrame(step);
      }
      requestAnimationFrame(step);
    });
  }, { threshold: 0.6 });
  els.forEach(function (el) { io.observe(el); });
}

/* Pause ambient videos when reduced motion or off-screen */
function initAmbientVideo() {
  var vids = $$("video[data-ambient]");
  vids.forEach(function (v) {
    if (REDUCED) { v.removeAttribute("autoplay"); v.pause(); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) v.play().catch(function () {});
        else v.pause();
      });
    }, { threshold: 0.1 });
    io.observe(v);
  });
}

/* ============================================================
   Klarna instalments (on-site messaging; payment happens in
   the Shopify checkout where Klarna must be enabled)
   ============================================================ */
function klarnaLine(amount, id) {
  var per = fmtPrice(amount / 3);
  return '<button type="button" class="klarna-line" data-klarna="' + amount.toFixed(2) + '"' + (id ? ' id="' + id + '"' : "") + '>' +
    '<span class="klarna-badge">Klarna.</span>' +
    "<span>3 pagos de <strong>" + per + "</strong> sin intereses. <u>Más info</u></span></button>";
}

function openKlarnaModal(amount) {
  var per = amount / 3;
  var rows = [["Hoy", per], ["En 30 días", per], ["En 60 días", per]];
  openModal(
    '<div class="klarna-sched">' +
    '<span class="klarna-badge" style="font-size:1rem">Klarna.</span>' +
    '<h3 style="margin-top:1rem">Paga en 3 plazos <em>sin intereses</em></h3>' +
    '<p class="k-sub">Divide tu compra de ' + fmtPrice(amount) + " en tres pagos automáticos.</p>" +
    rows.map(function (r) {
      return '<div class="k-row"><span>' + r[0] + "</span><b>" + fmtPrice(r[1]) + "</b></div>";
    }).join("") +
    '<p class="k-note">Sin intereses ni comisiones pagando a tiempo. Selecciona Klarna al finalizar la compra en el pago seguro de Shopify. Sujeto a aprobación.</p>' +
    "</div>"
  );
}

document.addEventListener("click", function (e) {
  var k = e.target.closest("[data-klarna]");
  if (k) openKlarnaModal(parseFloat(k.dataset.klarna));
});

/* Mobile hint: arrow under horizontal rails so customers know to swipe */
function initRailHints() {
  $$(".card-rail, .color-strip").forEach(function (rail) {
    if (rail.nextElementSibling && rail.nextElementSibling.classList.contains("rail-hint")) return;
    var hint = document.createElement("div");
    hint.className = "rail-hint";
    hint.setAttribute("aria-hidden", "true");
    hint.innerHTML = "Desliza para ver más " +
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6"><path d="M4 12h15m-6-6 6 6-6 6"/></svg>';
    rail.insertAdjacentElement("afterend", hint);
  });
}

/* Newsletter forms (front-end only) */
function initNewsletter() {
  $$("form[data-newsletter]").forEach(function (f) {
    f.addEventListener("submit", function (e) {
      e.preventDefault();
      var email = f.querySelector("input[type=email]");
      if (!email || !email.value) return;
      f.reset();
      toast("Gracias — te hemos apuntado a la lista. Tu −10% llegará a tu correo.");
    });
  });
}

/* Generic lead forms (wholesale / affiliates / contact) */
function initLeadForms() {
  $$("form[data-lead]").forEach(function (f) {
    f.addEventListener("submit", function (e) {
      e.preventDefault();
      f.reset();
      toast(f.dataset.lead || "Solicitud enviada. Te responderemos en 24–48 h.");
    });
  });
}

/* ---------- boot ---------- */
document.addEventListener("DOMContentLoaded", function () {
  Cart.load();
  injectChrome();
  initHeader();
  initReveals();
  initParallax();
  initCounters();
  initAmbientVideo();
  initNewsletter();
  initLeadForms();
  initRailHints();
  renderCartUI();
});
